import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';
@Component({
  selector: 'app-agences-nabeul',
  templateUrl: './agences-nabeul.component.html',
  styleUrls: ['./agences-nabeul.component.scss']
})
export class AgencesNabeulComponent implements OnInit {


  @ViewChild('agencyForm', { static: false })

  agencyForm: NgForm;
  p: Number = 1;
  lengthSociete=10
  totalSociete : any
  closeResult = '';
  search_name1:any;
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  AgenciesTunis:any

  constructor(private agenciesService: AgenciesService,private primengConfig: PrimeNGConfig,
    private searchService: SearchService ) { }


  ngOnInit() {
 
    this.getagencesNabeul();

  }
  getagencesNabeul() {
    this.agenciesService.getListAgenceNabeul().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log("liste des agences à nabeul", this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis.filter((agencie: any) => {
        return agencie.region === 'Nabeul'; 
        this.performSearch();// Filtre uniquement les promoteurs ayant la région "Tunis"
      });
        
    });
  }
  




  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any) {
    this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {

      console.log(this.dataSource.data);

    });
  
    
  }

 public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}

performSearch() {
  this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
}
}

